import { render, staticRenderFns } from "./starred-linked-application.vue?vue&type=template&id=28871626"
import script from "./starred-linked-application.vue?vue&type=script&lang=js"
export * from "./starred-linked-application.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports